unit UTimeDataForm;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, UMainConfig, Vcl.StdCtrls, WEBLib.StdCtrls,
  Vcl.Imaging.pngimage, Vcl.Controls, WEBLib.ExtCtrls, Types, Vcl.Grids,
  WEBLib.Grids, UTimeDataHelper, UZeitartList, UEssentialHelper, Vcl.Graphics,
  WEBLib.Buttons, UStampModel;

const
  ZrColCount = 12;

type
  TTimeDataForm = class(TForm)
    pnlHeader: TPanel;
    imgLogo: TImageControl;
    lblHeader: TLabel;
    btnBack: TImageControl;
    pnlFooter: TPanel;
    pnlStatus: TPanel;
    sgStatus: TStringGrid;
    pnlData: TPanel;
    pnlToolbar: TPanel;
    WebLabel1: TLabel;
    dtpVon: TDateTimePicker;
    WebLabel2: TLabel;
    dtpBis: TDateTimePicker;
    sgZrValues: TStringGrid;
    cbbPeriod: TComboBox;
    chkDecimalValues: TCheckBox;
    btnPrint: TSpeedButton;
    procedure WebFormResize(Sender: TObject);
    procedure btnBackClick(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    procedure WebFormOrientationChange(Sender: TObject;
      AOrientation: TScreenOrientation);
    procedure sgZaValuesClickCell(Sender: TObject; ACol, ARow: Integer);
    procedure dtpVonChange(Sender: TObject);
    procedure cbbPeriodChange(Sender: TObject);
    procedure btnPrintClick(Sender: TObject);
    procedure WebFormCreate(Sender: TObject);
  private
    zList: TStringList;
    FMainConfig: TMainConfig;
    FZrList: TZrList;
    FZeitartList: TZeitartList;
    FFakStamp: TStampModel;
    FStamp: TStampModel;
    function ZrColWidth: Integer;
    procedure ClearGrid;
    procedure GetForward(index: Integer);
    procedure GetForwardsCallback;
    procedure GetLastFakStamp;
    procedure GetSalden(index: Integer);
    procedure GetStatus;
    procedure GetZaSumTag(datum: TDateTime; index: Integer);
    procedure GetZaSumZr(index: Integer);
    procedure GetZeitarten;
    procedure GetZeitart(index: Integer);
    procedure GetZrValues;
    procedure AddForwards;
    procedure sgZaValuesInit;
    procedure sgZrValuesInit;
    procedure sgZrValuesFill;
    procedure SetMainConfig(const Value: TMainConfig);
    procedure SetZrList(const Value: TZrList);
    procedure SetZeitartList(const Value: TZeitartList);
    procedure SetFakStamp(const Value: TStampModel);
    procedure SetStamp(const Value: TStampModel);
  public
    property MainConfig: TMainConfig read FMainConfig write SetMainConfig;
    property ZrList: TZrList read FZrList write SetZrList;
    property ZeitartList: TZeitartList read FZeitartList write SetZeitartList;
    property Stamp: TStampModel read FStamp write SetStamp;
    property FakStamp: TStampModel read FFakStamp write SetFakStamp;
  protected procedure LoadDFMValues; override; end;

var
  TimeDataForm: TTimeDataForm;

implementation

uses
  UGridHelper, System.DateUtils, Math, UZrValueModel, UValueModel,
  UZeitartModel;

{$R *.dfm}
{ TTimeDataForm }

procedure TTimeDataForm.AddForwards;
var
  zrItem: TZrItem;
  zrValue: TZrValueModel;
begin
  zrItem := TZrItem.Create;
  zrValue := TZrValueModel.Create;
  zrValue.Zeitart := Bold('Vortrag');
  zrItem.ZrValueList.Add(zrValue);
  Self.ZrList.Insert(0, zrItem);
  zrItem := TZrItem.Create;
  zrValue := TZrValueModel.Create;
  zrValue.Zeitart := Bold('Summe ZR');
  zrItem.ZrValueList.Add(zrValue);
  Self.ZrList.Add(zrItem);
  zrItem := TZrItem.Create;
  zrValue := TZrValueModel.Create;
  zrValue.Zeitart := Bold('Saldo');
  zrItem.ZrValueList.Add(zrValue);
  Self.ZrList.Add(zrItem);
end;

procedure TTimeDataForm.btnBackClick(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
  Self.Close;
end;

procedure TTimeDataForm.btnPrintClick(Sender: TObject);
begin
  Self.sgZrValues.SaveToCSV('Export.csv', ';', true);
end;

procedure TTimeDataForm.cbbPeriodChange(Sender: TObject);
var
  zp: TDateTime;
begin
  Self.MainConfig.TimerReset;
  zp := date;
  case cbbPeriod.ItemIndex of
    0:
      begin
        dtpVon.date := StartOfTheMonth(zp);
        dtpBis.date := EndOfTheMonth(zp);
      end;
    1:
      begin
        zp := StartOfTheMonth(zp);
        zp := zp - 1;
        dtpVon.date := StartOfTheMonth(zp);
        dtpBis.date := zp;
      end;
    2:
      begin
        zp := StartOfTheMonth(zp);
        zp := zp - 1;
        zp := StartOfTheMonth(zp);
        zp := zp - 1;
        dtpVon.date := StartOfTheMonth(zp);
        dtpBis.DateTime := zp;
      end;
    3:
      begin
        dtpVon.date := StartOfTheWeek(zp);
        dtpBis.date := EndOfTheWeek(zp);
      end;
    4:
      begin
        zp := StartOfTheWeek(zp);
        zp := zp - 1;
        dtpVon.date := StartOfTheWeek(zp);
        dtpBis.date := zp;
      end;
    5:
      begin
        zp := StartOfTheWeek(zp);
        zp := zp - 1;
        zp := StartOfTheWeek(zp);
        zp := zp - 1;
        dtpVon.date := StartOfTheWeek(zp);
        dtpBis.date := zp;
      end;
    6:
      begin
        dtpVon.date := zp;
        dtpBis.date := zp;
      end;
    7:
      begin
        zp := zp - 1;
        dtpVon.date := zp;
        dtpBis.date := zp;
      end;
    8:
      begin
        zp := zp - 2;
        dtpVon.date := zp;
        dtpBis.date := zp;
      end;
  end;
  Self.GetZrValues;
end;

procedure TTimeDataForm.ClearGrid;
var
  i, j: Integer;
begin
  for i := 0 to sgZrValues.ColCount - 1 do
    for j := 0 to sgZrValues.RowCount - 1 do
      sgZrValues.Cells[i, j] := '';
end;

procedure TTimeDataForm.dtpVonChange(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
  Self.GetZrValues;
end;

procedure TTimeDataForm.GetForward(index: Integer);
var
  model: TValueModel;
  procedure Callback(Sender: TObject);
  var
    helper: TValueModel;
  begin
    if Sender is TValueModel then
    begin
      helper := Sender as TValueModel;
      sgZrValues.Cells[helper.Col, helper.Row] := AlignRight(helper.Value);
    end;
    Self.GetForward(index + 1);
  end;

begin
  if index < Self.ZeitartList.Count then
  begin
    if Self.ZeitartList.Items[index].ForwardAccount then
    begin
      model := TValueModel.Create;
      model.OnPropertyChanged := Callback;
      model.Row := 1;
      model.Col := ZrColCount + index;
      model.GetBalance(Self.MainConfig.Uri, Self.MainConfig.User.PersonalNr,
        Self.ZeitartList.Items[index].Id, dtpVon.date,
        chkDecimalValues.Checked);
    end
    else
      Self.GetForward(index + 1);
  end
  else
    Self.GetForwardsCallback;
end;

procedure TTimeDataForm.GetForwardsCallback;
begin
  Self.GetZaSumTag(dtpVon.date, 0);
end;

procedure TTimeDataForm.GetLastFakStamp;
var
  st: TStampModel;
  procedure Callback(Sender: TObject);
  begin
    if Sender is TStampModel then
    begin
      Self.FakStamp:=Sender as TStampModel;
      Self.WebFormResize(nil);
    end;
  end;

begin
  st := TStampModel.Create;
  st.PersonalNr := Self.MainConfig.User.PersonalNr;
  st.OnPropertyChanged := Callback;
  st.GetLastFakStamp(Self.MainConfig.Uri);
end;

procedure TTimeDataForm.GetSalden(index: Integer);
var
  model: TValueModel;
  procedure Callback(Sender: TObject);
  var
    helper: TValueModel;
  begin
    if Sender is TValueModel then
    begin
      helper := Sender as TValueModel;
      sgZrValues.Cells[helper.Col, helper.Row] := AlignRight(helper.Value);
    end;
    Self.GetSalden(index + 1);
  end;

begin
  if index < Self.ZeitartList.Count then
  begin
    if Self.ZeitartList.Items[index].ForwardAccount then
    begin
      model := TValueModel.Create;
      model.OnPropertyChanged := Callback;
      model.Col := index + ZrColCount;
      model.Row := sgZrValues.RowCount - 1;
      model.GetBalance(Self.MainConfig.Uri, Self.MainConfig.User.PersonalNr,
        Self.ZeitartList.Items[index].Id, dtpBis.date + 1,
        chkDecimalValues.Checked);
    end
    else
      Self.GetSalden(index + 1);
  end;
end;

procedure TTimeDataForm.GetStatus;
var
  st: TStampModel;
  procedure Callback(Sender: TObject);
  begin
    if Sender is TStampModel then
    begin
      Self.Stamp:=Sender as TStampModel;
      Self.WebFormResize(nil);
    end;
  end;

begin
  st := TStampModel.Create;
  st.PersonalNr := Self.MainConfig.User.PersonalNr;
  st.OnPropertyChanged := Callback;
  st.GetLastStamp(Self.MainConfig.Uri);
end;

procedure TTimeDataForm.GetZaSumTag(datum: TDateTime; index: Integer);
var
  model: TValueModel;
  i: Integer;
  procedure Callback(Sender: TObject);
  var
    helper: TValueModel;
  begin
    if Sender is TValueModel then
    begin
      helper := Sender as TValueModel;
      if not TValueModel.IsZero(helper.Value) then
        sgZrValues.Cells[helper.Col, helper.Row] := AlignRight(helper.Value);
    end;
    Self.GetZaSumTag(datum, index + 1);
  end;

begin
  if datum <= dtpBis.date then
  begin
    if index < Self.ZeitartList.Count then
    begin
      i := Self.ZrList.GetIndexByDate(datum);
      if i >= 0 then
      begin
        model := TValueModel.Create;
        model.OnPropertyChanged := Callback;
        model.Col := ZrColCount + index;
        model.Row := i + 1;
        model.GetZaSumTag(Self.MainConfig.Uri, Self.MainConfig.User.PersonalNr,
          Self.ZeitartList.Items[index].Id, datum, chkDecimalValues.Checked);
      end
      else
        Self.GetZaSumTag(datum, index + 1);
    end
    else
      Self.GetZaSumTag(datum + 1, 0);
  end
  else
    Self.GetZaSumZr(0);
end;

procedure TTimeDataForm.GetZaSumZr(index: Integer);
var
  model: TValueModel;
  procedure Callback(Sender: TObject);
  var
    helper: TValueModel;
  begin
    if Sender is TValueModel then
    begin
      helper := Sender as TValueModel;
      if not TValueModel.IsZero(helper.Value) then
        sgZrValues.Cells[helper.Col, helper.Row] := AlignRight(helper.Value);
    end;
    Self.GetZaSumZr(index + 1);
  end;

begin
  if index < Self.ZeitartList.Count then
  begin
    model := TValueModel.Create;
    model.OnPropertyChanged := Callback;
    model.Col := index + ZrColCount;
    model.Row := sgZrValues.RowCount - 2;
    model.GetZaSumZr(Self.MainConfig.Uri, Self.MainConfig.User.PersonalNr,
      Self.ZeitartList.Items[index].Id, dtpVon.date, dtpBis.date,
      chkDecimalValues.Checked);
  end
  else
    Self.GetSalden(0);
end;

procedure TTimeDataForm.GetZeitart(index: Integer);
var
  model: TZeitartModel;
  procedure Callback(Sender: TObject);
  begin
    if Sender is TZeitartModel then
      Self.ZeitartList.Add(Sender as TZeitartModel);
    Self.GetZeitart(index + 1);
  end;

begin
  if index < Self.zList.Count then
  begin
    model := TZeitartModel.Create;
    model.Id := StrToInt(Self.zList[index]);
    model.OnPropertyChanged := Callback;
    model.GetById(Self.MainConfig.Uri);
  end
  else
    Self.sgZaValuesInit;
end;

procedure TTimeDataForm.GetZeitarten;
begin
  if Self.ZeitartList = nil then
    Self.ZeitartList := TZeitartList.Create
  else
    Self.ZeitartList.Clear;
  if zList = nil then
    Self.zList := TStringList.Create;
  Self.zList.CommaText := Self.MainConfig.TimeDataConfig.ZeitartIds;
  Self.GetZeitart(0);
end;

procedure TTimeDataForm.GetZrValues;
  procedure Callback(Sender: TObject);
  begin
    if Sender is TZrList then
    begin
      Self.ZrList := Sender as TZrList;
      Self.AddForwards;
      Self.sgZrValuesInit;
      Self.sgZrValuesFill;
      Self.GetZeitarten;
    end;
  end;

begin
  Self.ClearGrid;
  Self.ZrList := TZrList.Create(Self.MainConfig.User.PersonalNr, dtpVon.date,
    dtpBis.date);
  Self.ZrList.OnPropertyChanged := Callback;
  Self.ZrList.CreateItems(Self.MainConfig.Uri);
end;

procedure TTimeDataForm.SetFakStamp(const Value: TStampModel);
begin
  FFakStamp := Value;
end;

procedure TTimeDataForm.SetMainConfig(const Value: TMainConfig);
begin
  FMainConfig := Value;
  Self.MainConfig.CurrentForm := Self.Name;
  ColorComponents(Self, Self.MainConfig.ColorConfig);
  pnlFooter.Caption := Self.MainConfig.Copyright;
  if Self.MainConfig.CommonConfig.WorkOrderTimes then
    Self.GetLastFakStamp;
  Self.WebFormResize(Self);
  Self.GetStatus;
  dtpBis.DateTime := EndOfTheMonth(date);
  dtpVon.DateTime := StartOfTheMonth(dtpBis.date);
  Self.GetZrValues;
end;

procedure TTimeDataForm.SetStamp(const Value: TStampModel);
begin
  FStamp := Value;
end;

procedure TTimeDataForm.SetZeitartList(const Value: TZeitartList);
begin
  FZeitartList := Value;
end;

procedure TTimeDataForm.SetZrList(const Value: TZrList);
begin
  FZrList := Value;
end;

procedure TTimeDataForm.sgZaValuesClickCell(Sender: TObject;
  ACol, ARow: Integer);
begin
  if sgZrValues.Row <> ARow then
    sgZrValues.Row := ARow;
end;

procedure TTimeDataForm.sgZaValuesInit;
var
  colWidth: Integer;
  i: Integer;
begin
  sgZrValues.ColCount := ZrColCount + Self.ZeitartList.Count;
  colWidth := (sgZrValues.Width - 36 - Self.ZrColWidth)
    div Max(1, Self.ZeitartList.Count);
  colWidth := Max(50, colWidth);
  for i := ZrColCount to sgZrValues.ColCount - 1 do
  begin
    sgZrValues.ColWidths[i] := colWidth;
    sgZrValues.Cells[i, 0] :=
      AlignRight(Bold(Self.ZeitartList.Items[i - ZrColCount].KurzBez));
  end;
  Self.GetForward(0);
end;

procedure TTimeDataForm.sgZrValuesFill;
var
  Row: Integer;
  i, j: Integer;
  zrItem: TZrItem;
begin
  Row := 1;
  for i := 0 to Self.ZrList.Count - 1 do
  begin
    zrItem := Self.ZrList.Items[i];
    if zrItem.datum > 0 then
    begin
      sgZrValues.Cells[2, Row] := FormatDateTime('dd.mm. ddd', zrItem.datum);
      if zrItem.Feiertag then
        sgZrValues.Cells[2, Row] := sgZrValues.Cells[2, Row] + '*';
    end;
    j := 0;
    while j < zrItem.ZrValueList.Count do
    begin
      sgZrValues.Cells[3, Row + j] := zrItem.ZrValueList.Items[j].Zeitart;
      sgZrValues.Cells[4, Row + j] := zrItem.ZrValueList.Items[j].BS1;
      if zrItem.ZrValueList.Items[j].Zeitpunkt1 > 0 then
        sgZrValues.Cells[5, Row + j] := FormatDateTime('dd.mm. hh:nn',
          zrItem.ZrValueList.Items[j].Zeitpunkt1);
      sgZrValues.Cells[6, Row + j] := zrItem.ZrValueList.Items[j].BS2;
      if zrItem.ZrValueList.Items[j].Zeitpunkt2 > 0 then
        sgZrValues.Cells[7, Row + j] := FormatDateTime('dd.mm. hh:nn',
          zrItem.ZrValueList.Items[j].Zeitpunkt2);
      if chkDecimalValues.Checked then
        sgZrValues.Cells[8, Row + j] :=
          AlignRight(ConvertToDecimal(zrItem.ZrValueList.Items[j].Value))
      else
        sgZrValues.Cells[8, Row + j] :=
          AlignRight(zrItem.ZrValueList.Items[j].Value);
      sgZrValues.Cells[10, Row + j] := zrItem.ZrValueList.Items[j].Kst;
      sgZrValues.Cells[11, Row + j] := zrItem.ZrValueList.Items[j].Bemerkung;
      Inc(j);
    end;
    Row := Row + Max(1, zrItem.ZrValueList.Count);
  end;

end;

procedure TTimeDataForm.sgZrValuesInit;
begin
  sgZrValues.ColCount := ZrColCount;
  sgZrValues.RowCount := Self.ZrList.GetCount + 1;
  sgZrValues.FixedCols := 0;
  sgZrValues.FixedRows := 1;
  sgZrValues.Cells[0, 0] := '';
  sgZrValues.Cells[1, 0] := Bold('Id');
  sgZrValues.Cells[2, 0] := Bold('Datum');
  sgZrValues.Cells[3, 0] := Bold('Zeitart');
  sgZrValues.Cells[4, 0] := Bold('BS1');
  sgZrValues.Cells[5, 0] := Bold('von');
  sgZrValues.Cells[6, 0] := Bold('BS2');
  sgZrValues.Cells[7, 0] := Bold('bis');
  sgZrValues.Cells[8, 0] := Bold('Wert');
  sgZrValues.Cells[9, 0] := '';
  sgZrValues.Cells[10, 0] := Bold('Kst');
  sgZrValues.Cells[11, 0] := Bold('Info');
  sgZrValues.ColWidths[0] := 5;
  sgZrValues.ColWidths[1] := 0;
  sgZrValues.ColWidths[2] := 55;
  sgZrValues.ColWidths[3] := 75;
  sgZrValues.ColWidths[4] := 30;
  sgZrValues.ColWidths[5] := 75;
  sgZrValues.ColWidths[6] := 30;
  sgZrValues.ColWidths[7] := 75;
  sgZrValues.ColWidths[8] := 35;
  sgZrValues.ColWidths[9] := 5;
  if (Self.Height < 480) or (Self.Width < 640) then
  begin
    sgZrValues.ColWidths[10] := 0;
    sgZrValues.ColWidths[11] := 0;
  end
  else
  begin
    sgZrValues.ColWidths[10] := 25;
    sgZrValues.ColWidths[11] := 100;
  end;
end;

procedure TTimeDataForm.WebFormCreate(Sender: TObject);
begin
  Self.Stamp := nil;
  Self.FakStamp := nil;
end;

procedure TTimeDataForm.WebFormOrientationChange(Sender: TObject;
  AOrientation: TScreenOrientation);
begin
  Self.WebFormResize(Sender);
end;

procedure TTimeDataForm.WebFormResize(Sender: TObject);
var
  colWidth, i: Integer;
begin
  if (Self.Height < 480) or (Self.Width < 640) then
  begin
    btnBack.Width := 24;
    btnBack.Height := 24;
    btnBack.Top := 4;
    btnBack.Left := 4;
    lblHeader.Font.Size := 10;
    lblHeader.Top := 7;
    imgLogo.Width := 74;
    imgLogo.Height := 24;
    imgLogo.Top := 4;
    pnlHeader.Height := 32;
    pnlFooter.Visible := false;
    lblHeader.Caption := 'Zeitdaten';
    sgZrValues.ColWidths[10] := 0;
    sgZrValues.ColWidths[11] := 0;
    if Self.MainConfig <> nil then
      SetStatusGrid(sgStatus, Stamp, FFakStamp, true, pnlStatus,
        Self.MainConfig.User);
  end
  else
  begin
    btnBack.Width := 48;
    btnBack.Height := 48;
    btnBack.Top := 8;
    btnBack.Left := 8;
    lblHeader.Font.Size := 16;
    lblHeader.Top := 16;
    imgLogo.Width := 148;
    imgLogo.Height := 48;
    imgLogo.Top := 8;
    pnlHeader.Height := 64;
    pnlFooter.Visible := true;
    lblHeader.Caption := 'Winzeit - WebPortal - Zeitdaten';
    sgZrValues.ColWidths[10] := 25;
    sgZrValues.ColWidths[11] := 100;
    if Self.MainConfig <> nil then
      SetStatusGrid(sgStatus, Stamp, FFakStamp, false, pnlStatus,
        Self.MainConfig.User);
  end;
  pnlHeader.Width := Self.ClientWidth;
  pnlFooter.Width := pnlHeader.Width;
  lblHeader.Left := 64;
  lblHeader.Width := pnlHeader.ClientWidth - btnBack.Width - imgLogo.Width - 32;
  imgLogo.Left := pnlHeader.ClientWidth - imgLogo.Width - 16;
  if Self.ZeitartList <> nil then
    colWidth := (sgZrValues.Width - 36 - Self.ZrColWidth)
      div Max(1, Self.ZeitartList.Count)
  else
    colWidth := sgZrValues.Width - 36 - Self.ZrColWidth;
  colWidth := Max(50, colWidth);
  for i := ZrColCount to sgZrValues.ColCount - 1 do
    sgZrValues.ColWidths[i] := colWidth;
end;

procedure TTimeDataForm.WebFormShow(Sender: TObject);
begin
  Self.WebFormResize(Sender);
end;

function TTimeDataForm.ZrColWidth: Integer;
var
  i: Integer;
begin
  Result := 0;
  for i := 0 to ZrColCount - 1 do
    Result := Result + sgZrValues.ColWidths[i];
end;

procedure TTimeDataForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlHeader := TPanel.Create(Self);
  imgLogo := TImageControl.Create(Self);
  lblHeader := TLabel.Create(Self);
  btnBack := TImageControl.Create(Self);
  pnlFooter := TPanel.Create(Self);
  pnlStatus := TPanel.Create(Self);
  sgStatus := TStringGrid.Create(Self);
  pnlData := TPanel.Create(Self);
  sgZrValues := TStringGrid.Create(Self);
  pnlToolbar := TPanel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  dtpVon := TDateTimePicker.Create(Self);
  dtpBis := TDateTimePicker.Create(Self);
  cbbPeriod := TComboBox.Create(Self);
  chkDecimalValues := TCheckBox.Create(Self);
  btnPrint := TSpeedButton.Create(Self);

  pnlHeader.BeforeLoadDFMValues;
  imgLogo.BeforeLoadDFMValues;
  lblHeader.BeforeLoadDFMValues;
  btnBack.BeforeLoadDFMValues;
  pnlFooter.BeforeLoadDFMValues;
  pnlStatus.BeforeLoadDFMValues;
  sgStatus.BeforeLoadDFMValues;
  pnlData.BeforeLoadDFMValues;
  sgZrValues.BeforeLoadDFMValues;
  pnlToolbar.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  dtpVon.BeforeLoadDFMValues;
  dtpBis.BeforeLoadDFMValues;
  cbbPeriod.BeforeLoadDFMValues;
  chkDecimalValues.BeforeLoadDFMValues;
  btnPrint.BeforeLoadDFMValues;
  try
    Name := 'TimeDataForm';
    Width := 1000;
    Height := 548;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnOrientationChange', 'WebFormOrientationChange');
    SetEvent(Self, 'OnResize', 'WebFormResize');
    SetEvent(Self, 'OnScroll', 'WebFormResize');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    pnlHeader.SetParentComponent(Self);
    pnlHeader.Name := 'pnlHeader';
    pnlHeader.Left := 0;
    pnlHeader.Top := 0;
    pnlHeader.Width := 1000;
    pnlHeader.Height := 64;
    pnlHeader.Align := alTop;
    pnlHeader.Caption := 'pnlHeader';
    pnlHeader.Color := clSkyBlue;
    pnlHeader.ShowCaption := False;
    imgLogo.SetParentComponent(pnlHeader);
    imgLogo.Name := 'imgLogo';
    imgLogo.Left := 480;
    imgLogo.Top := 8;
    imgLogo.Width := 148;
    imgLogo.Height := 48;
    imgLogo.HeightPercent := 100.000000000000000000;
    imgLogo.WidthPercent := 100.000000000000000000;
    imgLogo.Picture.LoadFromFile('UTimeDataForm.pnlHeader.imgLogo.Picture.png');
    lblHeader.SetParentComponent(pnlHeader);
    lblHeader.Name := 'lblHeader';
    lblHeader.Left := 64;
    lblHeader.Top := 16;
    lblHeader.Width := 410;
    lblHeader.Height := 30;
    lblHeader.Alignment := taCenter;
    lblHeader.AutoSize := False;
    lblHeader.Caption := 'Winzeit - WebPortal - Zeitdaten';
    lblHeader.Font.Charset := DEFAULT_CHARSET;
    lblHeader.Font.Color := clWindowText;
    lblHeader.Font.Height := -21;
    lblHeader.Font.Name := 'Segoe UI';
    lblHeader.Font.Style := [fsBold];
    lblHeader.HeightPercent := 100.000000000000000000;
    lblHeader.ParentFont := False;
    lblHeader.WidthPercent := 100.000000000000000000;
    btnBack.SetParentComponent(pnlHeader);
    btnBack.Name := 'btnBack';
    btnBack.Left := 16;
    btnBack.Top := 16;
    btnBack.Width := 32;
    btnBack.Height := 32;
    btnBack.HeightPercent := 100.000000000000000000;
    btnBack.WidthPercent := 100.000000000000000000;
    btnBack.ChildOrder := 2;
    SetEvent(btnBack, Self, 'OnClick', 'btnBackClick');
    btnBack.Picture.LoadFromFile('UTimeDataForm.pnlHeader.btnBack.Picture.png');
    pnlFooter.SetParentComponent(Self);
    pnlFooter.Name := 'pnlFooter';
    pnlFooter.Left := 0;
    pnlFooter.Top := 524;
    pnlFooter.Width := 1000;
    pnlFooter.Height := 24;
    pnlFooter.Align := alBottom;
    pnlFooter.Alignment := taLeftJustify;
    pnlFooter.Caption := 'pnlFooter';
    pnlFooter.ChildOrder := 1;
    pnlFooter.Color := clSkyBlue;
    pnlStatus.SetParentComponent(Self);
    pnlStatus.Name := 'pnlStatus';
    pnlStatus.Left := 0;
    pnlStatus.Top := 64;
    pnlStatus.Width := 1000;
    pnlStatus.Height := 28;
    pnlStatus.Align := alTop;
    pnlStatus.Caption := 'pnlStatus';
    pnlStatus.ChildOrder := 2;
    pnlStatus.ShowCaption := False;
    sgStatus.SetParentComponent(pnlStatus);
    sgStatus.Name := 'sgStatus';
    sgStatus.Left := 0;
    sgStatus.Top := 0;
    sgStatus.Width := 1000;
    sgStatus.Height := 28;
    sgStatus.Align := alClient;
    sgStatus.ColCount := 4;
    sgStatus.FixedCols := 0;
    sgStatus.RowCount := 2;
    sgStatus.FixedRows := 0;
    sgStatus.Font.Charset := ANSI_CHARSET;
    sgStatus.Font.Color := clNavy;
    sgStatus.Font.Height := -16;
    sgStatus.Font.Name := 'Segoe UI Semibold';
    sgStatus.Font.Style := [fsBold];
    sgStatus.Options := [goRangeSelect,goFixedRowDefAlign];
    sgStatus.ParentFont := False;
    sgStatus.ScrollBars := ssNone;
    sgStatus.TabOrder := 0;
    sgStatus.RangeEdit.Max := 100.000000000000000000;
    sgStatus.RangeEdit.Step := 1.000000000000000000;
    sgStatus.HeightPercent := 100.000000000000000000;
    sgStatus.WidthPercent := 100.000000000000000000;
    pnlData.SetParentComponent(Self);
    pnlData.Name := 'pnlData';
    pnlData.Left := 0;
    pnlData.Top := 124;
    pnlData.Width := 1000;
    pnlData.Height := 400;
    pnlData.Align := alClient;
    pnlData.Caption := 'pnlData';
    pnlData.ChildOrder := 3;
    pnlData.ShowCaption := False;
    sgZrValues.SetParentComponent(pnlData);
    sgZrValues.Name := 'sgZrValues';
    sgZrValues.Left := 0;
    sgZrValues.Top := 0;
    sgZrValues.Width := 1000;
    sgZrValues.Height := 400;
    sgZrValues.Align := alClient;
    sgZrValues.ColCount := 12;
    sgZrValues.RowCount := 2;
    sgZrValues.Options := [goFixedHorzLine,goHorzLine,goRangeSelect,goColSizing,goRowSelect,goFixedRowDefAlign];
    sgZrValues.TabOrder := 0;
    sgZrValues.RangeEdit.Max := 100.000000000000000000;
    sgZrValues.RangeEdit.Step := 1.000000000000000000;
    sgZrValues.HeightPercent := 100.000000000000000000;
    sgZrValues.WidthPercent := 100.000000000000000000;
    pnlToolbar.SetParentComponent(Self);
    pnlToolbar.Name := 'pnlToolbar';
    pnlToolbar.Left := 0;
    pnlToolbar.Top := 92;
    pnlToolbar.Width := 1000;
    pnlToolbar.Height := 32;
    pnlToolbar.Align := alTop;
    pnlToolbar.Caption := 'pnlToolbar';
    pnlToolbar.ChildOrder := 4;
    pnlToolbar.ShowCaption := False;
    WebLabel1.SetParentComponent(pnlToolbar);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 4;
    WebLabel1.Top := 9;
    WebLabel1.Width := 74;
    WebLabel1.Height := 15;
    WebLabel1.Caption := 'Zeitraum: von';
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.WidthPercent := 100.000000000000000000;
    WebLabel2.SetParentComponent(pnlToolbar);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 172;
    WebLabel2.Top := 9;
    WebLabel2.Width := 15;
    WebLabel2.Height := 15;
    WebLabel2.Caption := 'bis';
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.WidthPercent := 100.000000000000000000;
    dtpVon.SetParentComponent(pnlToolbar);
    dtpVon.Name := 'dtpVon';
    dtpVon.Left := 80;
    dtpVon.Top := 4;
    dtpVon.Width := 90;
    dtpVon.Height := 23;
    dtpVon.BorderStyle := bsSingle;
    dtpVon.ChildOrder := 1;
    dtpVon.Color := clWhite;
    dtpVon.Date := 45376.394582118050000000;
    dtpVon.Role := '';
    dtpVon.Text := '';
    SetEvent(dtpVon, Self, 'OnChange', 'dtpVonChange');
    dtpBis.SetParentComponent(pnlToolbar);
    dtpBis.Name := 'dtpBis';
    dtpBis.Left := 188;
    dtpBis.Top := 4;
    dtpBis.Width := 90;
    dtpBis.Height := 23;
    dtpBis.BorderStyle := bsSingle;
    dtpBis.ChildOrder := 3;
    dtpBis.Color := clWhite;
    dtpBis.Date := 45376.401038935180000000;
    dtpBis.Role := '';
    dtpBis.Text := '';
    SetEvent(dtpBis, Self, 'OnChange', 'dtpVonChange');
    cbbPeriod.SetParentComponent(pnlToolbar);
    cbbPeriod.Name := 'cbbPeriod';
    cbbPeriod.Left := 280;
    cbbPeriod.Top := 4;
    cbbPeriod.Width := 90;
    cbbPeriod.Height := 23;
    cbbPeriod.HeightPercent := 100.000000000000000000;
    cbbPeriod.Text := 'Dieser Monat';
    cbbPeriod.WidthPercent := 100.000000000000000000;
    SetEvent(cbbPeriod, Self, 'OnChange', 'cbbPeriodChange');
    cbbPeriod.ItemIndex := 0;
    cbbPeriod.Items.BeginUpdate;
    try
      cbbPeriod.Items.Clear;
      cbbPeriod.Items.Add('Dieser Monat');
      cbbPeriod.Items.Add('Vormonat');
      cbbPeriod.Items.Add('Vorvormonat');
      cbbPeriod.Items.Add('Diese Woche');
      cbbPeriod.Items.Add('Vorwoche');
      cbbPeriod.Items.Add('Vorvorwoche');
      cbbPeriod.Items.Add('Heute');
      cbbPeriod.Items.Add('Gestern');
      cbbPeriod.Items.Add('Vorgestern');
    finally
      cbbPeriod.Items.EndUpdate;
    end;
    chkDecimalValues.SetParentComponent(pnlToolbar);
    chkDecimalValues.Name := 'chkDecimalValues';
    chkDecimalValues.Left := 376;
    chkDecimalValues.Top := 4;
    chkDecimalValues.Width := 98;
    chkDecimalValues.Height := 23;
    chkDecimalValues.Caption := 'Dezimalwerte';
    chkDecimalValues.ChildOrder := 5;
    chkDecimalValues.HeightPercent := 100.000000000000000000;
    chkDecimalValues.WidthPercent := 100.000000000000000000;
    SetEvent(chkDecimalValues, Self, 'OnClick', 'cbbPeriodChange');
    btnPrint.SetParentComponent(pnlToolbar);
    btnPrint.Name := 'btnPrint';
    btnPrint.Left := 512;
    btnPrint.Top := 4;
    btnPrint.Width := 24;
    btnPrint.Height := 24;
    btnPrint.Hint := 'Daten exportieren';
    btnPrint.Caption := 'btnPrint';
    btnPrint.Color := clNone;
    btnPrint.Glyph.LoadFromFile('UTimeDataForm.pnlToolbar.btnPrint.Glyph.png');
    btnPrint.GlyphSize := 16;
    btnPrint.HeightPercent := 100.000000000000000000;
    btnPrint.ShowHint := True;
    btnPrint.TabOrder := 4;
    btnPrint.WidthPercent := 100.000000000000000000;
    SetEvent(btnPrint, Self, 'OnClick', 'btnPrintClick');
  finally
    pnlHeader.AfterLoadDFMValues;
    imgLogo.AfterLoadDFMValues;
    lblHeader.AfterLoadDFMValues;
    btnBack.AfterLoadDFMValues;
    pnlFooter.AfterLoadDFMValues;
    pnlStatus.AfterLoadDFMValues;
    sgStatus.AfterLoadDFMValues;
    pnlData.AfterLoadDFMValues;
    sgZrValues.AfterLoadDFMValues;
    pnlToolbar.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    dtpVon.AfterLoadDFMValues;
    dtpBis.AfterLoadDFMValues;
    cbbPeriod.AfterLoadDFMValues;
    chkDecimalValues.AfterLoadDFMValues;
    btnPrint.AfterLoadDFMValues;
  end;
end;

end.
